import api from '@/plugins/request/index';
// 客源管理
export const getEsfCustomeList = async (params, type = 'get') => {
  return api[type](`/esf/v1/customer/customer-index`, params).then(res => res);
}
// 获取二手房通用配置
export const getEsfConfig = async (params, type = 'get') => {
  return api[type](`/esf/v1/config/esf`, params).then(res => res);
}
// 获取二手房客源关联表单报名列表
export const getFormRecords = async (params, type = 'get') => {
  return api[type]('/esf/v1/customer/form-records', params).then(res => res);
}
// 获取二手房关联通话列表
export const getEsfAllRecords = async (params, type = 'get') => {
  return api[type](`/esf/v1/customer/call-records`, params).then(res => res);
}
// 下载/播放录音
export const downloadEsfCall = async (id, type = 'put') => {
  return api[type](`/esf/v1/customer/download-call/${id}`).then(res => res);
}
// 出售房源列表
export const getEsfHouseList = async (params, type = 'get') => {
  return api[type](`/esf/v1/esf-house-list`, params).then(res => res);
}
// 强制下架出售房源
export const esfForceOff = async (id, params, type = 'put') => {
  return api[type](`/esf/v1/esf-houses/${id}/force-off`, params).then(res => res);
}
// 出售房源详情
export const getEsfDetail = async (id, type = 'get') => {
  return api[type](`/esf/v1/esf-house-detail/${id}`).then(res => res);
}
// 出租房源列表
export const getRentHouseList = async (params, type = 'get') => {
  return api[type](`/esf/v1/rent-house-list`, params).then(res => res);
}
// 强制下架出租房源
export const rentForceOff = async (id, params, type = 'put') => {
  return api[type](`/esf/v1/rent-houses/${id}/force-off`, params).then(res => res);
}
// 出租房源详情
export const getRentDetail = async (id, type = 'get') => {
  return api[type](`/esf/v1/rent-house-detail/${id}`).then(res => res);
}
